import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class RequireElevatedJitaPrompt extends Component {
  getElevatedJitaLink() {
    return `${getFullUrl('tools', {
      domainOverride: 'hubteam'
    })}/login/jita?jitaType=ELEVATED&email=${encodeURIComponent(this.props.currentUserEmail)}&jitaDuration=60&loginPortalId=${encodeURIComponent(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
    PortalIdParser.get())}&loginPortalName=${encodeURIComponent(this.props.portalDomain)}&loginRedirectUrl=${encodeURIComponent(window.location.href)}`;
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      className: "p-y-8",
      children: /*#__PURE__*/_jsxs("div", {
        className: "p-all-8 display-flex justify-center align-center",
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "keys",
            className: "p-right-13",
            height: 150
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "svh-workspace-ui-lib.requireElevatedJita.title"
            })
          }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "svh-workspace-ui-lib.requireElevatedJita.paragraph",
            className: "display-block"
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "tertiary-light",
            className: "m-top-4",
            href: this.getElevatedJitaLink(),
            size: "sm",
            role: "button",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "svh-workspace-ui-lib.requireElevatedJita.buttonText"
            })
          })]
        })]
      })
    });
  }
}
RequireElevatedJitaPrompt.displayName = 'RequireElevatedJitaPrompt';
export default RequireElevatedJitaPrompt;